import { Platform, useWindowDimensions } from 'react-native';
import config from '~/config';
import { global } from '~/constants/global';

export const useCsvExportEnabled = () => {
    const { width } = useWindowDimensions();

    return config.CSV_EXPORT === 'true' && Platform.OS === 'web' && width > global.DESKTOP_MIN_WIDTH;
};
